import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from './navbar'
import Footer from './footer'
import baseUrl from '../base_url'
import axios from 'axios'
import { Link } from 'react-router-dom'
import Typography from '@mui/material/Typography';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { Box, useMediaQuery } from '@mui/material'

const StepIndicator = ({activeStep, setActiveStep}) => {
    const handleStepChange = (e) => {
        setActiveStep(parseInt(e.target.value))
    }
    const steps = ["Select Product" , "Select Reason" , "Add Details" , "Review"]
    const isMobile = useMediaQuery('(max-width:768px)');

    return (
        <div className='indicator relative flex items-center justify-between w-full px-3 md:px-10'>
          <div className='w-full'>
              <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep - 1} alternativeLabel={isMobile} orientation={isMobile ? "horizontal" : "horizontal"}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{isMobile ? (index === activeStep - 1 ? label : "") : label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
          </div>
        </div>
    );
};

function ParticularOrder(props) {
  const item = props.data;

  function setSel(e) {
    const id = e.currentTarget.dataset.id;
    props.setSelectedProduct(id);
  }

  const isSelected = props.selectedProductId === item.productId;

  return (
    <div
      onClick={setSel}
      data-id={item.productId}
      className={`flex items-center py-4 px-3 md:px-5 cursor-pointer border-2 transition-all duration-200 ${
        isSelected ? 'border-blue-500' : 'border-transparent'
      }`}
    >
      <div className="w-16 h-16 md:w-24 md:h-24 flex-shrink-0">
        <img
          src={item.image}
          alt="product"
          className="w-full h-full object-contain"
        />
      </div>
      <div className="ml-3 md:ml-4 flex-grow">
        <div className="text-black-400 font-medium text-sm md:text-base">
          {item.title}
        </div>
        <p className="text-xs md:text-sm text-gray-500 mt-1">Quantity: {item.quantity}</p>
        <p className="text-xs md:text-sm font-medium mt-1">Rs. {item.price}</p>
      </div>
    </div>
  );
}

const ProductInfo = ({ data, setActiveStep, setSelectedProduct, selectedProductId }) => {
  function handleNext() {
    if (selectedProductId) {
      setSelectedProduct(selectedProductId);
      setActiveStep(2);
    }
  }

  return (
    <>
      <h2 className="text-base md:text-lg font-medium px-3 md:px-5 mb-3">Select Product to Return</h2>
      {data?.cart.map((item) => {
        if(item.returned === true) {
          return ("")
        };
        return(
        <ParticularOrder
          key={item.productId}
          data={item}
          setSelectedProduct={setSelectedProduct}
          selectedProductId={selectedProductId}
        />
      )})}

      <div className='w-full flex items-center px-3 md:pr-[40px] justify-end pt-[30px]'>
        <button 
          onClick={handleNext} 
          disabled={!selectedProductId}
          className={`px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl ${selectedProductId ? 'bg-green-400 hover:bg-green-600 hover:text-white' : 'bg-gray-300 cursor-not-allowed'}`}
        >
          Next
        </button>
      </div>
    </>
  );
};

const SelectReason = ({ setActiveStep, returnReason, setReturnReason }) => {
  const reasons = [
    'Bought by Mistake',
    'Better price available',
    'Performance or quality not adequate',
    'Incompatible or not useful',
    'Product damaged, but shipping box OK',
    'Item arrived too late',
    'Missing parts or accessories',
    'Both product and shipping box damaged',
    'Wrong item was sent',
    'Item defective or does not work',
    'No longer needed',
    'Did not approve purchase',
    'other'
  ];

  function handleNext() {
    if (returnReason) {
      setActiveStep(3);
    }
  }

  function handleBack() {
    setActiveStep(1);
  }

  return (
    <>
      <h2 className="text-base md:text-lg font-medium px-3 md:px-5 mb-3">Select Return Reason</h2>
      <div className="px-3 md:px-5 space-y-2 md:space-y-3">
        {reasons.map((reason) => (
          <div 
            key={reason} 
            onClick={() => setReturnReason(reason)}
            className={`p-3 md:p-4 border rounded-md cursor-pointer transition-all text-sm md:text-base ${
              returnReason === reason ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'
            }`}
          >
            {reason}
          </div>
        ))}
      </div>
      <div className='w-full flex items-center px-3 md:px-[40px] justify-between pt-[30px]'>
        <button 
          onClick={handleBack} 
          className="px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl border border-gray-300 hover:bg-gray-100"
        >
          Back
        </button>
        <button 
          onClick={handleNext} 
          disabled={!returnReason}
          className={`px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl ${returnReason ? 'bg-green-400 hover:bg-green-600 hover:text-white' : 'bg-gray-300 cursor-not-allowed'}`}
        >
          Next
        </button>
      </div>
    </>
  );
};

const AddDetails = ({ setActiveStep, description, setDescription, image, setImage }) => {
  function handleNext() {
    // Only proceed if both description and image are provided
    if (description && image && image.file) {
      setActiveStep(4);
    }
  }

  function handleBack() {
    setActiveStep(2);
  }

  function handleImageChange(e) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage({
          file,
          preview: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  }

  // Check if both fields are valid for enabling the Next button
  const isFormValid = description && image && image.file;

  return (
    <>
      <h2 className="text-base md:text-lg font-medium px-3 md:px-5 mb-3">Add Details</h2>
      <div className="px-3 md:px-5 space-y-4">
        <div>
          <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Please describe the issue in detail"
            className="w-full border border-gray-300 rounded-md p-2 md:p-3 h-24 md:h-32 text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1">
            Upload Image <span className="text-red-500">*</span>
          </label>
          <input 
            type="file" 
            accept="image/*"
            onChange={handleImageChange}
            className="block w-full text-xs md:text-sm text-gray-500 file:mr-3 md:file:mr-4 file:py-1 md:file:py-2 file:px-3 md:file:px-4 file:rounded-md file:border-0 file:text-xs md:file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            required
          />
          {!image && (
            <p className="text-xs md:text-sm text-red-500 mt-1">Please upload an image of the product issue</p>
          )}
          {image && image.preview && (
            <div className="mt-2 md:mt-3">
              <img 
                src={image.preview} 
                alt="Preview" 
                className="h-32 md:h-40 object-contain border rounded-md" 
              />
            </div>
          )}
        </div>
      </div>
      <div className='w-full flex items-center px-3 md:px-[40px] justify-between pt-[30px]'>
        <button 
          onClick={handleBack} 
          className="px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl border border-gray-300 hover:bg-gray-100"
        >
          Back
        </button>
        <button 
          onClick={handleNext} 
          disabled={!isFormValid}
          className={`px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl ${isFormValid ? 'bg-green-400 hover:bg-green-600 hover:text-white' : 'bg-gray-300 cursor-not-allowed'}`}
        >
          Next
        </button>
      </div>
    </>
  );
};

const ReviewSubmit = ({ setActiveStep, product, selectedProduct, returnReason, description, image, submitReturn }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  function handleBack() {
    setActiveStep(3);
  }

  async function handleSubmit() {
    setIsSubmitting(true);
    setSubmitError("");
    
    try {
      await submitReturn();
      // Handle success - could redirect or show success message
    } catch (error) {
      setSubmitError(error.response?.data?.message || "Failed to submit return request");
    } finally {
      setIsSubmitting(false);
    }
  }

  // Find the selected product details from the product cart
  const selectedProductDetails = product?.cart.find(item => item._id === selectedProduct);

  return (
    <>
      <h2 className="text-base md:text-lg font-medium px-3 md:px-5 mb-3">Review and Submit</h2>
      <div className="px-3 md:px-5 space-y-3 md:space-y-4">
        <div className="border rounded-md p-3 md:p-4">
          <h3 className="font-medium text-sm md:text-base mb-2">Selected Product</h3>
          {selectedProductDetails && (
            <div className="flex items-center">
              <div className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0">
                <img
                  src={selectedProductDetails.image}
                  alt="product"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="ml-2 md:ml-3">
                <div className="font-medium text-xs md:text-base">{selectedProductDetails.title}</div>
                <p className="text-xs md:text-sm text-gray-500">Quantity: {selectedProductDetails.quantity}</p>
                <p className="text-xs md:text-sm">Rs. {selectedProductDetails.price}</p>
              </div>
            </div>
          )}
        </div>

        <div className="border rounded-md p-3 md:p-4">
          <h3 className="font-medium text-sm md:text-base mb-2">Return Reason</h3>
          <p className="text-xs md:text-base">{returnReason}</p>
        </div>

        <div className="border rounded-md p-3 md:p-4">
          <h3 className="font-medium text-sm md:text-base mb-2">Description</h3>
          <p className="whitespace-pre-line text-xs md:text-base">{description}</p>
        </div>

        {image && image.preview && (
          <div className="border rounded-md p-3 md:p-4">
            <h3 className="font-medium text-sm md:text-base mb-2">Uploaded Image</h3>
            <img 
              src={image.preview} 
              alt="Return Img" 
              className="h-32 md:h-40 object-contain" 
            />
          </div>
        )}

        {submitError && (
          <div className="bg-red-50 border border-red-200 text-red-600 p-2 md:p-3 rounded-md text-xs md:text-sm">
            {submitError}
          </div>
        )}
      </div>
      <div className='w-full flex items-center px-3 md:px-[40px] justify-between pt-[30px]'>
        <button 
          onClick={handleBack} 
          className="px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl border border-gray-300 hover:bg-gray-100"
          disabled={isSubmitting}
        >
          Back
        </button>
        <button 
          onClick={handleSubmit} 
          disabled={isSubmitting}
          className="px-3 md:px-[15px] py-2 md:py-[8px] text-sm md:text-base rounded-xl md:rounded-2xl bg-green-400 hover:bg-green-600 hover:text-white"
        >
          {isSubmitting ? "Submitting..." : "Submit Return Request"}
        </button>
      </div>
    </>
  );
};

export default function ReturnPage() {
    const { id } = useParams();
    const [activeStep, setActiveStep] = useState(1);
    const [product, setProduct] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [returnReason, setReturnReason] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const isMobile = useMediaQuery('(max-width:768px)');
    
    const navigate = useNavigate();

    useEffect(() => {
      async function fetchOrder() {
        try {
          const accessToken = localStorage.getItem("accessToken");
          const config = {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
          };

          try {
            const checkReturnable = await axios.get(
              `${baseUrl}api/orders/checkReturn/${id}`,
              config
            );
            console.log(checkReturnable);
          } catch (err) {
            console.log("error while checking if it is returnable or not");
            console.log(err);
            navigate(`/order/${id}`);
            return;
          }

          const response = await axios.post(
            `${baseUrl}api/orders/get-order/${id}`,
            {},
            config
          );

          setProduct(response.data.data);
          setIsLoading(false);
        } catch (err) {
          console.log("Error while fetching product:", err);
          setIsLoading(false);
        }
      }

      fetchOrder();
    }, [id, navigate]);

    async function submitReturn() {
        const formData = new FormData();
        formData.append("orderId", id);
        formData.append("productId", selectedProduct);
        formData.append("reason", returnReason);
        formData.append("description", description);
        if (image && image.file) {
            formData.append("image", image.file);
        }
        for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
        }

        const accessToken = localStorage.getItem("accessToken")
        const response = await axios.post(
            `${baseUrl}api/orders/return`,
            formData,
            { 
                withCredentials: true,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${accessToken}`,

                }
            }
        );

        if (response.data.success) {
            setSubmitSuccess(true);
        } else {
            throw new Error(response.data.message || "Failed to submit return request");
        }
    }

    if (isLoading) {
        return (
            <div className='flex flex-col items-center bg-[#faf9f8]'>
                <Navbar/>
                <div className='w-full min-h-[60vh] flex py-[32px] justify-center'>
                    <div className='returnArea w-full md:w-[50%] px-4 md:px-0 h-[auto] min-h-60 flex-col max-w-[1024px]'>
                        Loading...
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }

    if (submitSuccess) {
        return (
            <div className='flex flex-col items-center bg-[#faf9f8]'>
                <Navbar/>
                <div className='w-full min-h-[60vh] flex py-[32px] justify-center'>
                    <div className='returnArea w-[90%] md:w-[50%] h-[auto] min-h-60 flex-col max-w-[1024px] bg-white border border-gray-200 rounded-md p-4 md:p-8 text-center'>
                        <div className="bg-green-100 text-green-600 rounded-full w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h1 className='text-xl md:text-2xl font-semibold mb-2 md:mb-3'>Return Request Submitted</h1>
                        <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">Your return request has been successfully submitted. We will review it and get back to you soon.</p>
                        <Link to="/orders" className="bg-blue-500 text-white px-4 md:px-6 py-2 text-sm md:text-base rounded-md hover:bg-blue-600 transition-colors">
                            Back to Orders
                        </Link>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }

    return (
        <div className='flex flex-col items-center bg-[#faf9f8]'>
            <Navbar/>
            <div className='w-full min-h-[60vh] flex py-4 md:py-[32px] justify-center pt-12'>
                <div className='returnArea w-[95%] md:w-[50%] h-[auto] min-h-60 flex-col max-w-[1024px] px-2 md:px-0'>
                    <h1 className='text-lg md:text-[22px] font-semibold'>Return Request</h1>
                    <p className="text-sm md:text-base">Please complete the form below to initiate your return request</p>

                    <div className="overflow-hidden py-4 md:py-6 flex flex-col gap-3 md:gap-[15px]">
                        <div className='border border-gray-200 rounded-md bg-white overflow-hidden py-3 md:py-5 flex items-center'>
                            <StepIndicator
                                activeStep={activeStep}
                                setActiveStep={setActiveStep}
                            />
                        </div>
                        <div className='border border-gray-200 rounded-md bg-white overflow-hidden py-3 md:py-5 flex flex-col'>
                            {activeStep === 1 && (
                                <ProductInfo
                                    data={product}
                                    setSelectedProduct={setSelectedProduct}
                                    selectedProductId={selectedProduct}
                                    setActiveStep={setActiveStep}
                                />
                            )}
                            {activeStep === 2 && (
                                <SelectReason 
                                    setActiveStep={setActiveStep}
                                    returnReason={returnReason}
                                    setReturnReason={setReturnReason}
                                />
                            )}
                            {activeStep === 3 && (
                                <AddDetails 
                                    setActiveStep={setActiveStep}
                                    description={description}
                                    setDescription={setDescription}
                                    image={image}
                                    setImage={setImage}
                                />
                            )}
                            {activeStep === 4 && (
                                <ReviewSubmit 
                                    setActiveStep={setActiveStep}
                                    product={product}
                                    selectedProduct={selectedProduct}
                                    returnReason={returnReason}
                                    description={description}
                                    image={image}
                                    submitReturn={submitReturn}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}